import dayjs from 'dayjs';

export const date = dayjs;
